module.exports={render:function (){with(this) {
  return _h('section', {
    staticClass: "hero is-fullheight main-background"
  }, [_h('router-view'), " ", _h('footer-comp', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!isAnimatingMode),
      expression: "!isAnimatingMode"
    }]
  }), " ", _h('modal')])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07ededa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 123
// module chunks = 2